import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/upload.ts

var upload_exports = {};

__export(upload_exports, {
  blobToFile: function blobToFile() {
    return _blobToFile;
  },
  fileToBlob: function fileToBlob() {
    return _fileToBlob;
  },
  uploadMedia: function uploadMedia() {
    return _uploadMedia;
  },
  uploadMediaDirect: function uploadMediaDirect() {
    return _uploadMediaDirect;
  }
});

import retry from "async-retry";
import _ from "lodash";

var getFileBlob = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fileUri) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();

              xhr.onload = function () {
                return resolve(xhr.response);
              };

              xhr.onerror = function (e) {
                return reject(e);
              };

              xhr.responseType = "blob";
              xhr.open("GET", fileUri, true);
              xhr.send(null);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getFileBlob(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getFileBlobWithRetry = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fileUri) {
    var retries,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            retries = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 5;
            return _context3.abrupt("return", retry( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(bail) {
                var blob;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return getFileBlob(fileUri);

                      case 2:
                        blob = _context2.sent;
                        return _context2.abrupt("return", blob);

                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x3) {
                return _ref3.apply(this, arguments);
              };
            }(), {
              retries: retries,
              minTimeout: 1e3,
              maxTimeout: 1500
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getFileBlobWithRetry(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var _uploadMedia = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, media) {
    var uri, processedUri, _media$uploadInfo, storage, key, formData, data;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            uri = media.uri, processedUri = media.processedUri, _media$uploadInfo = media.uploadInfo, storage = _media$uploadInfo.storage, key = _media$uploadInfo.key, formData = _media$uploadInfo.formData;
            data = getUploadData(processedUri || uri, _objectSpread({
              storage: storage,
              key: key
            }, formData));
            return _context4.abrupt("return", fetcher_default.upload(url, data));

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function _uploadMedia(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var _uploadMediaDirect = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5) {
    var uri, blob, processedUri, platform, _ref5$uploadInfo, url, storage, formData, data;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            uri = _ref5.uri, blob = _ref5.blob, processedUri = _ref5.processedUri, platform = _ref5.platform, _ref5$uploadInfo = _ref5.uploadInfo, url = _ref5$uploadInfo.url, storage = _ref5$uploadInfo.storage, formData = _ref5$uploadInfo.formData;

            if (!(platform === "web")) {
              _context5.next = 3;
              break;
            }

            return _context5.abrupt("return", fetcher_default.uploadDirect(url, storage === "aliyun" ? getUploadDataForAliyun(blob, formData) : blob));

          case 3:
            if (!(storage === "aliyun")) {
              _context5.next = 7;
              break;
            }

            data = getUploadDataForAliyun(blob, formData);
            _context5.next = 10;
            break;

          case 7:
            _context5.next = 9;
            return getFileBlobWithRetry(processedUri || uri);

          case 9:
            data = _context5.sent;

          case 10:
            return _context5.abrupt("return", fetcher_default.uploadDirect(url, platform, data));

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function _uploadMediaDirect(_x6) {
    return _ref6.apply(this, arguments);
  };
}();

var getUploadData = function getUploadData(uri, formData) {
  var data = new FormData();

  _.each(formData, function (value, key) {
    if (value instanceof Date) {
      data.append(key, value.toISOString());
    } else {
      data.append(key, String(value));
    }
  });

  data.append("name", "file");
  data.append("file", {
    uri: uri,
    name: "file.jpg",
    type: "image/jpg"
  });
  return data;
};

var getUploadDataForAliyun = function getUploadDataForAliyun(blob, formData) {
  var data = new FormData();

  _.each(formData, function (value, key) {
    if (value instanceof Date) {
      data.append(key, value.toISOString());
    } else {
      data.append(key, String(value));
    }
  });

  data.append("success_action_status", "200");
  data.append("file", blob);
  return data;
};

var _blobToFile = function _blobToFile(theBlob, fileName) {
  return new File([theBlob], fileName);
};

var _fileToBlob = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(file) {
    var arrayBuffer;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return file.arrayBuffer();

          case 2:
            arrayBuffer = _context6.sent;
            return _context6.abrupt("return", new Blob([new Uint8Array(arrayBuffer)], {
              type: file.type
            }));

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function _fileToBlob(_x7) {
    return _ref7.apply(this, arguments);
  };
}();

export { _uploadMedia as uploadMedia, _uploadMediaDirect as uploadMediaDirect, _blobToFile as blobToFile, _fileToBlob as fileToBlob, upload_exports };